<button (click)="openChatbot($event)" class="hover:opacity-80 transition-all">
  <img
    src="https://kr1-api-object-storage.nhncloudservice.com/v1/AUTH_2355fbddd74e499f89b6640b98832b2c/file-storage/malirang_chatbot_icon.svg"
  />
</button>
